/**
 * useEmailSocket - Socket listener for real-time email updates
 * Invalidates email queries when new messages arrive
 */

import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSocket } from '@/contexts/SocketContext';
import { SOCKET_EVENTS as Events } from '@troia-v3/types';

export const useEmailSocket = () => {
  const queryClient = useQueryClient();
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;

    const handleEmailUpdate = () => {
      queryClient.invalidateQueries({ queryKey: ['email-conversations'] });
    };

    socket.on(Events.CONVERSATION_MESSAGE, handleEmailUpdate);
    socket.on(Events.CONVERSATION_UPDATED, handleEmailUpdate);

    return () => {
      socket.off(Events.CONVERSATION_MESSAGE, handleEmailUpdate);
      socket.off(Events.CONVERSATION_UPDATED, handleEmailUpdate);
    };
  }, [socket, queryClient]);
};
